import React from "react";
import { useEffect, useState, useMemo,useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getbillslist,getaccountcharts,getsupplierslist,searchpropertywithfolio,paybillsapi,addupdatebill,getBillDetailsById,FilePath,cancelBills} from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner,uploadToS3WithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus,eBillsStatus,AccountChartType } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { HiOutlinePlusSmall } from "react-icons/hi2";
import { message,Select,Spin,Table,Button  } from 'antd';
import CustomModal from "../../../input-components/Modal";
import { useFormik } from "formik";
import SelectBox from "../../../input-components/selectBoxNew";
import debounce from "lodash/debounce";
import TextBox from "../../../input-components/textbox";
import ShowValue from "../../../input-components/ShowValue";
import FileUpload from "../../../input-components/documentUpload";
import { format } from 'date-fns';
import { FaDownload } from "react-icons/fa";
import { billsValidation } from "../../../../components/CommonSection/Schema/schema";
import { PaperClipOutlined } from "@ant-design/icons";

const todayFormatted = format(new Date(), "yyyy-MM-dd"); // ✔️ format for input

const initialValues = {
    date: todayFormatted,
    accounts: "",
    details: "",
    taxInc: false,
    totalAmt: "",
    fromInv:"",
    supplier:"",
    jobReference:"",
    folio:"",
    status:false
};

const ListBills = () => {
    let selectedFile;
    const [billsLists, setBillsLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const navigate = useNavigate();
    const [propertyType, setPropertyType] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(2);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [openAddProperty, setOpenAddProperty] = useState(false);
    const [getDetails, setGetDetails] = useState(null);
    const [addNew, setAddNew] = useState(false);
    const [edit, setEdit] = useState(false);
    const [view, setView] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const [accArr, setAccArr] = useState(10);
    const [fetchingSupplier, setFetchingSupplier] = useState(false);
    const [optionSupplier, setOptionSupplier] = useState([]);
    const [supplierValue, setSupplierValues] = useState("");
    const fetchRef = useRef(0);
    const [rowIds,setRowIds] = useState(null);
     const [propertyimageitems, setPropertyimageitems] = useState([]);
     const [propertyDocuments, setPropertyDocuments] = useState("");
     const [supplierLabel,setSupplierLabel]= useState("");
     const [propertyLabel,setPropertyLabel]= useState("");
    const inputRef = useRef();
    const isTaxArr = [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
    ];

    const [searchValue, setSearchValues] = useState("");
    const formRef = useRef();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                   setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, []);

    useEffect(() => {
        if (userId) getSupportList(1, 10);
    }, [userId, searchText, purpose, propertyType]);
    
    var url = new URL(window.location.href);
    var BillId = url.searchParams.get("BillId");

       useEffect(() => {
            if (BillId) {
                GetDetailsApi(BillId)
            }
        }, [BillId])

        useEffect(() => {
            getAccountList();
        }, [])

         const GetDetailsApi = () => {
                const url = getBillDetailsById + `?BillId=${BillId}`;
                makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
                    .then((response) => {
                        if (response.status === ActionStatus.Successfull) {
                            setGetDetails(response.object);
                            setFieldValue("accounts", response.object?.accountChartId?.toString());
                            setFieldValue("jobReference", response.object?.jobReference);
                            setFieldValue("details", response.object?.details);
                            setFieldValue("date", format(new Date(response.object?.dueDate), 'yyyy-MM-dd'));
                            setFieldValue("totalAmt", response.object?.amount);
                            setFieldValue("taxInc", response.object?.isTax ?  response.object?.isTax : false);
                            setSearchValues(response.object?.propertyId);
                            setSupplierValues(response.object?.supplierContactId)
                            setSupplierLabel(response.object?.supplierName)
                            setPropertyLabel(response.object?.propertyAddress)
                            if (response.object?.attachment) {
                                const fileName = response.object.attachment.split('/').pop();
                                const imageItem = {
                                  id: Math.floor(Math.random() * 1000000),
                                  src: FilePath + response.object.attachment,
                                  width: 1,
                                  height: 1,
                                  fileName: fileName
                                };
                                setPropertyimageitems([imageItem]);
                              }
                        }
                        console.log(values.taxInc)

                    })
                    .catch((error) => {
                        console.error("Error fetching ticket details:", error);
                    })
                    .finally(() => {
                        //setLoading(false); // Set loading to false once API call completes
                    });
            };


     const getAccountList = () => {
            const baseUrl = getaccountcharts + `?type=${AccountChartType.Expense}`;
            makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        const accArr = response.object.map(item => ({
                            label: item.text,
                            value: item.value
                        }));
                        setAccArr(accArr)
                    } else {
                        alert(`Message: ${response.message}`);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        };

    const getSupportList = (currentPage, totalRows) => {
        const baseUrl = getbillslist;
        let data = {
            AgencyId: agencyID,
              SortBy:"AddedOn",
              SortOrder:"DESC",
              Status: purpose,
              PageNo: currentPage,
        };
        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let billsData = response.list;
                    let billsist = billsData
                        .map((inv) => ({
                            Bill: inv.id,
                            supplier: inv.supplier,
                            Property: inv.propertyName,
                            ref: inv.jobReference,
                            dueDate:  format(new Date(inv.dueDate), 'dd/MM/yyyy hh:mm'),
                            Details: inv.details,
                            Amount: inv.amount.toFixed(2),
                            id: inv.uid,
                            isLowBalance:inv.isLowBalance,
                            attachment: inv.attachment_Path ? true : false,
                            attachmentPath: inv.attachment_Path
                        }));
                    setTotalPages(response.totalCount)
                    setBillsLists(billsist);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    
    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getSupportList(pageNumber, totalRows);
    };

     const {
            errors,
            values,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            setValues,
            resetForm
        } = useFormik({
            initialValues: initialValues,
            //validationSchema: billsValidation,
            onSubmit: (values, action) => {
                AddupdateBills()
            },
        });
    
    
        const AddupdateBills = () => {
            const baseUrl = addupdatebill;
            let data = {
                Id: getDetails?.id ? getDetails?.id : 0,
                SupplierContactId: supplierValue ? supplierValue : null,
                PropertyId: searchValue,
                AccountChartId: parseInt(values.accounts),
                JobReference: values.jobReference,
                Details: values.details,
                DueDate: values.date,
                IsTax: values.taxInc,
                Amount: parseFloat(values.totalAmt),
                //Status: values.status,
                //Folio: agencyID,
                attachment: propertyDocuments,
            };
            makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        message.success(response.message)
                        getSupportList(1,10);
                        setOpenAddProperty(false);
                    } else {
                        //ToastRef.current.notify(["error", "error"]);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        };
    
   
    const handleSupportTickets = () => {
        setOpenAddProperty(true);
        setEdit(false);
        setView(false);
        setGetDetails(null);
        setAddNew(true);
        setFieldValue("accounts", "");
        setFieldValue("jobReference","");
        setFieldValue("details", "");
        setFieldValue("date", todayFormatted);
        setFieldValue("totalAmt", "");
        setFieldValue("taxInc", false);
        setSearchValues("");
        setSupplierValues("")
        setSupplierLabel("")
        setPropertyLabel("")
        setPropertyimageitems([]);
    }

   
    const actions = [
        { icon: "/assets/images/dots.svg",key:"View", onClick: (e, data) => handleView(e, data) },
        // { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
    ]

    const handleView = (e, data) => {
        console.log(data,'data')
        const baseUrl = window.location.pathname; // Get the current path without query params
        const newUrl = `${baseUrl}?BillId=${data.id}`; // Append the contactUID to the URL
        navigate(newUrl);
        setOpenAddProperty(true);
        setView(true);
    }

    const closeProperty = () => {
        const baseUrl = window.location.pathname;
        navigate(baseUrl);
        setOpenAddProperty(false);
        setEdit(false);
        setView(false);
        setGetDetails(null);
        setAddNew(false);
    }

     const debounceFetcher = useMemo(() => {
            const loadOptions = (value) => {
                fetchRef.current += 1;
                const fetchId = fetchRef.current;
                setOptions([]);
                setFetching(true);
                const baseUrl = searchpropertywithfolio;
                const data = {
                    Search: value,
                    RecordsPerPage: 10,
                    PageNo: 1,
                };
    
                makeRequestWithSpinner(
                    showSpinner,
                    hideSpinner,
                    baseUrl,
                    "post",
                    data,
                    "",
                    false
                )
                    .then((response) => {
                        if (response.status === 1) {
                            let landingPageListData = response.list;
    
                            // Transform data to match Select options
                            const transformedData = landingPageListData.map((item) => ({
                                value: item.id,
                                label: item.name + `(${item.ownerFolio})`,
                            }));
    
                            // Update options and fetching state
                            if (fetchId === fetchRef.current) {
                                setOptions(transformedData);
                                setFetching(false);
                            }
                        } else {
                            setFetching(false);
                        }
                    })
                    .catch((error) => {
                        setFetching(false);
                    });
            };
            return debounce(loadOptions, 800);
        }, []);
    
        const handleSearchProperty = (value) => {
            debounceFetcher(value);
            setSearchValues(value.value);
            setPropertyLabel(value.label)
        };
    
        const handleClearProperty = () => {
            setSearchValues("");
            setPropertyLabel("      ")
        };

          useEffect(() => {
            agentUIDRef.current = agencyID;
          }, [agencyID]);

        const agentUIDRef = useRef(agencyID);

         const debounceFetcherSupplier = useMemo(() => {
                const loadOptions = (value) => {
                     const agentId = agentUIDRef.current;
                    fetchRef.current += 1;
                    const fetchId = fetchRef.current;
                    setOptionSupplier([]);
                    setFetchingSupplier(true);
                    const baseUrl = getsupplierslist ;
                    const data = {
                        Search: value.label,
                        AgencyId: agentId
                    };
        
                    makeRequestWithSpinner(
                        showSpinner,
                        hideSpinner,
                        baseUrl,
                        "post",
                        data,
                        "",
                        false
                    )
                        .then((response) => {
                            if (response.status === 0) {
                                let supplierListData = response.list;
                                // Transform data to match Select options
                                const transformedData = supplierListData.map((item) => ({
                                    label: item.name + `(${item.accountFolio})`,
                                    value: item.contactId,
                                }));
        
                                // Update options and fetching state
                                if (fetchId === fetchRef.current) {
                                    setOptionSupplier(transformedData);
                                    setFetchingSupplier(false);
                                }
                            } else {
                                setFetchingSupplier(false);
                            }
                        })
                        .catch((error) => {
                            setFetchingSupplier(false);
                        });
                };
                return debounce(loadOptions, 800);
            }, []);
        
            const handleSearchSupplier = (value) => {
                debounceFetcherSupplier(value);
                setSupplierValues(value.value);
                setSupplierLabel(value.label)
            };
        
            const handleClearSupplier = () => {
                setSupplierValues("");
                setSupplierLabel("")
            };

            const paybills = () => {
                const baseUrl = paybillsapi;
                let data = {
                    BillIds: rowIds,
                    AgencyId: agencyID,
                };
                makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
                    .then((response) => {
                        if (response.status === ActionStatus.Successfull) {
                            message.success(response.message)
                            getSupportList(1,10);
                        } else {
                            //ToastRef.current.notify(["error", "error"]);
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
            };

            const onSelectedRowKeysChange = (data, id) => {
                console.log(id)
                // const selectedIds = id.map(row => row.id).join(',');
                // setRowIds(selectedIds)

                  const selectedIds = id.map(item => item.Bill);
                setRowIds(selectedIds)
            }

            const handleStatClick = (selectedPurpose) => {
                if(selectedPurpose === "Dashboard"){
                  setPurpose("")
                }else{
                  setPurpose(selectedPurpose);
                }
              };

              const columns = [
                {
                  title: "Contact",
                  dataIndex: "ownerName",
                  key: "ownerName",
                  render: (text, record) => (
                    <span
                      onClick={() => handlefolio("Owner", record.folio)}
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    >
                      {text}
                    </span>
                  ),
                },
                {
                  title: "Folio",
                  dataIndex: "folio",
                  key: "folio",
                  render: (text) => <span onClick={()=> handlefolio("Owner",text)} style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
                },
                {
                  title: "Chart Account",
                  dataIndex: "accountName",
                  key: "accountName",
                },
                {
                  title: "Detail",
                  dataIndex: "details",
                  key: "details",
                },
                {
                  title: "Tax",
                  dataIndex: "isTax",
                  key: "isTax",
                  render: (value) => (value ? "Yes" : "No"),
                },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  key: "amount",
                  render: (amount) => `$${amount.toFixed(2)}`,
                },
                {
                    title: "Attachment",
                    dataIndex: "attachment",
                    key: "attachment",
                    render: (attachment) =>
                      attachment ? (
                        <PaperClipOutlined
                          onClick={() => window.open(`${FilePath}${attachment}`, "_blank")}
                          style={{ fontSize: "18px", color: "#1890ff", cursor: "pointer" }}
                          title="Open Attachment"
                        />
                      ) : null,
                  },
              ];
            
        
              const billsData = getDetails
            ? [
                {
                  key: getDetails?.id,
                  ownerName: getDetails?.ownerName || "N/A",
                  folio: getDetails?.ownerFolio || "N/A",
                  accountName: getDetails?.accountChart || "N/A",
                  details: getDetails?.details || "N/A",
                  isTax: getDetails?.isTax,
                  amount: getDetails?.amount || 0,
                  attachment: getDetails?.attachment || ""
                },
              ]
            : [];

            const handlefolio = (data,folio) => {
                navigate(`/agency/accounts/folio?type=${data}&folio=${folio}`);
                }

                const handleProperty = (data) => {
                    navigate(`/agency/viewPropertyDetails?propertyUID=${data}`);
                }

                  const handleFileChange = async (e, indexforfiles) => {
                        for (let i = 0; i < e.target.files.length; i++) {
                            selectedFile = e.target.files[i];
                            await handleUpload(indexforfiles);
                        }
                    };
                
                    const handleUpload = async (indexforfiles) => {
                        await uploadToS3WithSpinner(
                            showSpinner,
                            hideSpinner,
                            "bills/",
                            "bills",
                            selectedFile
                        ).then((returnData) => {
                            if (returnData.status == ActionStatus.Successfull) {
                                //ToastRef.current.notify(["success", "File uploaded successfully"]);
                                const fileName1 = returnData.Key.split('/').pop();
                                const transformedItem = {
                                    id: Math.floor(Math.random() * 1000000),
                                    src: FilePath + returnData.Key,
                                    width: 1,
                                    height: 1,
                                    fileName: fileName1
                                };
                                setPropertyimageitems((prevItems) => [...prevItems, transformedItem]);
                                setPropertyDocuments(returnData.Key);
                            } else {
                                //ToastRef.current.notify(["error", "Error uploading file. Please try again."]);
                
                            }
                        });
                    };

                const select = (event) => {
                    inputRef.current.click();
                };

                   const handleDownload = () => {
                        const fileUrl = `${FilePath}${getDetails?.attachment}`;
                        window.open(fileUrl, '_blank');
                    };
                
                
                    const extractFileName = (path) => {
                        return path.split('/').pop();
                    };

                    const tabColumns = {
                        Amount: {
                          colorMap: {
                            "45451": "gray",
                            "4545": "green",
                          },
                          defaultColor: 'blue'
                        }
                      };

                      const handleEdit = () => {
                        setEdit(true);
                        setView(false);
                        setAddNew(true)
                      }

                       const deletBill = async (data) => {
                                    makeRequestWithSpinner(
                                      showSpinner,
                                      hideSpinner,
                                      `${cancelBills}?uids=${data}`,
                                      "delete"
                                    )
                                      .then((returnData) => {
                                        if (returnData.status == ActionStatus.Successfull) {
                                          ToastRef.current.notify(["success", returnData.message]);
                                          setOpenAddProperty(false)
                                        } else {
                                          ToastRef.current.notify(["error", returnData.message]);
                                        }
                                      })
                                      .catch((error) => {
                                        ToastRef.current.notify(["error", error]);
                                      });
                                  };
    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Bills"} goback={false} extraData={true}  extraContent={
                        <div className="property-details-buttons">
                            <button onClick={handleSupportTickets} className="main-subnav-btn" type="submit">
                                <HiOutlinePlusSmall style={{ fontSize: '24px' }} /> Add Bills
                            </button>
                            <button onClick={paybills} className="main-subnav-btn" type="submit">
                                Pay Bills
                            </button>
                        </div>
                    }/>
                    <div className="material-work-desk-new bg-white m-3">
                             <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
                                     <div className="">
                                       <span
                                         className={`stat-items ${purpose === eBillsStatus.Due ? 'active' : ''}`}
                                         onClick={() => handleStatClick(eBillsStatus.Due)}
                                       >
                                         Due
                                       </span>
                                       <span
                                         className={`stat-items ${purpose === eBillsStatus.Paid ? 'active' : ''}`}
                                         onClick={() => handleStatClick(eBillsStatus.Paid)}
                                       >
                                         Paid
                                       </span>
                                       <span
                                         className={`stat-items ${purpose === eBillsStatus.Future ? 'active' : ''}`}
                                         onClick={() => handleStatClick(eBillsStatus.Future)}
                                       >
                                         Future
                                       </span>
                       
                                     </div>
                                   </div>
                        <AntdTableExample
                            showCheckbox
                            label="List of Bills"
                            dataSource={billsLists}
                            globalSearch
                            hideCol={"id,uid,isLowBalance,attachmentPath"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            actions={actions}
                            onRowClick={handleView}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            tabColumns={tabColumns}
                        />
                    </div>
                    <CustomModal  title={view ? `Bill #${getDetails?.id} - ${getDetails?.details}` : edit ? "Update Bills" : "Add Bills"} width={view ? 700 : 1100} closable={closeProperty} visible={openAddProperty} onCancel={closeProperty}
                        modalData={
                            <div>

                                <div>
                                    {view && (
                                        <div className="details-form p-3">
                                        
                                            <div className="contacts-group">
                                           
                                                <ShowValue Label='Created Date' setData={getDetails?.addedOn ? format(new Date(getDetails.addedOn), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='Reference' setData={getDetails?.jobReference ? getDetails?.jobReference : "N/A"} />
                                                <ShowValue Label='Supplier' setData={getDetails?.supplierName ? getDetails?.supplierName : "N/A"} />
                                                <ShowValue Label='Due Date' setData={getDetails?.dueDate ? format(new Date(getDetails.dueDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                                <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                                                <ShowValue Label='Processed By' setData={getDetails?.processedBy ? getDetails?.processedBy : "N/A"} />
                                                {getDetails?.attachment && (
                                                    <div className={`row`}>
                                                        <div className={"label"}>
                                                            <div style={{ color: "#5E696E", fontWeight: '500' }}>{"Document"}:</div>
                                                        </div>
                                                        <div className={"value"} style={{ cursor: 'pointer' }} onClick={handleDownload}>
                                                            {extractFileName(getDetails.attachment)}
                                                            <span className="ml-2 icon" title="Download"><FaDownload /></span>
                                                        </div>
                                                    </div>
                                                )}
                                                <h6 style={{ marginTop: "20px" }}>Bill Details</h6>
                                                <Table columns={columns} dataSource={billsData} pagination={false} />

                                                {/* Total Section */}
                                                <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                                    Total: ${getDetails?.amount ? getDetails.amount.toFixed(2) : "0.00"}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {!view && (
                                        <div>
                                            {(addNew) ? (
                                                <form ref={formRef} onSubmit={handleSubmit} className="details-form" style={{ display: 'initial', width: '100%' }}>
                                                <div className="d-flex">
                                                        <div style={{ width: "40%" }}>
                                                        <TextBox isMandatory colVal={12} value={values.date} type="date" name="date" label={"Date"} onChange={handleChange} onBlur={handleBlur} error={errors.date} touched={touched.date} />

                                                            <div className="col-12 col-lg-12 col-md-12 col-sm-12" >
                                                                <label className='s1'>
                                                                    Supplier <span style={{color:'red'}}>*</span>
                                                                </label>
                                                                <Select value={supplierLabel} style={{ width: '100%', height: '40px' }} className="landingPageSearchs" mode="single" showSearch placeholder="Search for supplier" labelInValue filterOption={false} onSearch={debounceFetcherSupplier} notFoundContent={fetchingSupplier ? <Spin size="small" /> : null} options={optionSupplier} onChange={handleSearchSupplier} allowClear onClear={handleClearSupplier} />
                                                                {supplierLabel === "" ? (
                                                                            <p className="form-error mt-2">{"Supplier is required"}</p>
                                                                        ) : null}
                                                            </div>
                                                            <SelectBox isMandatory colVal={12} value={values.accounts} name="accounts" label={"Account"} options={accArr} onBlur={handleBlur} onChange={(val) => setFieldValue("accounts", val.value)} error={errors.accounts} touched={touched.accounts} />

                                                            <div className="col-12 col-lg-12 col-md-12 col-sm-12" >
                                                                <label className='s1'>
                                                                    Property <span style={{color:'red'}}>*</span>
                                                                </label>
                                                                <Select value={propertyLabel} style={{ width: '100%', height: '40px' }} className="landingPageSearchs" mode="single" showSearch placeholder="Search for Property" labelInValue filterOption={false} onSearch={debounceFetcher} notFoundContent={fetching ? <Spin size="small" /> : null} options={options} onChange={handleSearchProperty} allowClear onClear={handleClearProperty} />
                                                                {propertyLabel === "" ? (
                                                                            <p className="form-error mt-2">{"Property is required"}</p>
                                                                        ) : null}
                                                            </div>
                                                            <TextBox isMandatory colVal={12} value={values.jobReference} name="jobReference" label={"Job Reference"} onChange={handleChange} onBlur={handleBlur} error={errors.jobReference} touched={touched.jobReference} />
                                                            <TextBox isMandatory colVal={12} value={values.details} name="details" label={"Details"} onChange={handleChange} onBlur={handleBlur} error={errors.details} touched={touched.details} />
                                                            <TextBox isMandatory colVal={12} value={values.totalAmt} name="totalAmt" label={"Total Amount"} onChange={handleChange} error={errors.totalAmt} onBlur={handleBlur} touched={touched.totalAmt} />

                                                            {/* <SelectBox colVal={12} value={values.status} name="status" label={"Status"} options={isTaxArr} onChange={(val) => setFieldValue("status", val.value)} onBlur={handleBlur} error={errors.status} touched={touched.status} /> */}

                                                            <div className="col-12 col-lg-6 col-md-12 col-sm-12">
                                                                <div style={{ display: "flex", gap: "15px", alignItems: "center", marginTop: "5px" }}>
                                                                    <label style={{ display: 'flex', alignItems: 'center', fontFamily: 'inter', color: 'gray', fontWeight: '500' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="taxInc"
                                                                            value="true"
                                                                            checked={values.taxInc}
                                                                            onChange={() => setFieldValue("taxInc", !values.taxInc)}
                                                                            className="mr-2"
                                                                        />
                                                                        Tax Inc
                                                                    </label>
                                                                </div>
                                                                {touched.taxInc && errors.taxInc && (
                                                                    <div className="form-error">{errors.taxInc}</div>
                                                                )}
                                                            </div>


                                                        </div>
                                                        <div style={{ width: "60%" }}>
                                                            <FileUpload
                                                                label="Upload Image"
                                                                inputRef={inputRef}
                                                                onClickHandler={select}
                                                                handleFileChange={handleFileChange}
                                                                images={propertyimageitems}
                                                                setImages={setPropertyimageitems}
                                                                isViewDoc={true}
                                                                iwidth="600px"
                                                                iheight="500px"
                                                            />
                                                        </div>
                                                        
                                                    </div>
                                                  
                                                </form>
                                            ) : null}
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        footer={
                            <div>
                                {view ?
                                    <div className="d-flex justify-content-end mt-2">
                                        {!getDetails?.isPaid ?
                                            <div className="d-flex" style={{ marginLeft: "-10px" }}>
                                            <Button onClick={() => deletBill(getDetails?.uid)}  style={{ background: "#fff", color: "gray" }} className="ml-2 mr-2" type="default" >
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleEdit} style={{ background: "#fff", color: "steelblue", border: "1px solid steelblue" }}  className="mr-2" type="default" >
                                                    Edit
                                                </Button>
                                              
                                                <Button  style={{ background: "steelblue", color: "white" }} className="ml-2 mr-2" type="default" >
                                                    Pay
                                                </Button>
                                            </div> : null}
                                    </div> : 
                                    <div className="property-details-buttons">
                                                        <button
                                                            className="pdb-cancel"
                                                            type="reset"
                                                            onClick={closeProperty}
                                                        >
                                                            Cancel
                                                        </button>
                                            <button
                                                className="pdb-save-changes"
                                                type="button"
                                                onClick={() => formRef.current?.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }))}
                                            >
                                                Submit
                                            </button>

                                                    </div>}
                            </div>
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default ListBills;
